'use strict';

/* eslint-disable */
if (process.env.SPA_DEV) {
	module.exports = require('./WMCompanyPagesSPA.dev');
} else {
	module.exports = require('./WMCompanyPagesSPA.build');
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/index.js
// module id = 95fg
// module chunks = 62 63